import type { ProjectMediaFiles } from '../model/project';
import { IMAGE_EXTS, VIDEO_EXTS } from './compressMedia';

export type MediaCollection = 'images' | 'files' | 'quotes';

export interface MediaEntry {
  collection: MediaCollection;
  id: string;
  name: string;
  bucketFilePath: string;
  publicFileURL?: string;
}

export const getFileExtension = (fileName: string) => fileName.split('.').pop()?.toLowerCase() ?? '';

export const getMediaEntries = (
  media: ProjectMediaFiles | null | undefined,
  collection: MediaCollection
): MediaEntry[] => {
  const pairs = Object.entries(media ?? {});
  return pairs.map(([name, file]) => ({
    collection,
    id: `${collection}:${name}`,
    name,
    bucketFilePath: file.bucketFilePath,
    publicFileURL: file.publicFileURL,
  }));
};

export const isVideoEntry = (entry: MediaEntry) => VIDEO_EXTS.has(getFileExtension(entry.name));
export const isImageEntry = (entry: MediaEntry) => IMAGE_EXTS.has(getFileExtension(entry.name));
export const isVisualEntry = (entry: MediaEntry) => isImageEntry(entry) || isVideoEntry(entry);

export const getPdfEntries = (media: ProjectMediaFiles | null | undefined, collection: MediaCollection) => {
  const all = getMediaEntries(media, collection);
  return all.filter((entry) => getFileExtension(entry.name) === 'pdf');
};

export const getFileEntries = (media: ProjectMediaFiles | null | undefined, collection: MediaCollection) => {
  const all = getMediaEntries(media, collection);
  return all.filter((entry) => !isVisualEntry(entry));
};
